import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/creditors.js';
import q from '../query.js';
export const creditorsEntity = 'creditors';
export const creditorKey = (id) => `creditors-${id}`;
export const useCreditor = (id) => q.query(creditorKey(id), () => api.get(id), keys.read.item(creditorsEntity, id), { enabled: id != null });
const allCreditorsKey = () => `all-creditors`;
export const useAllCreditors = (disabled) => q.query(allCreditorsKey(), () => api.getAllCreditors(), keys.read.collection(creditorsEntity), {
    enabled: !disabled,
});
const accessCreditorsKey = () => `access-creditors`;
export const useAccessCreditors = () => q.query(accessCreditorsKey(), () => api.accessTo(), keys.read.collection(creditorsEntity));
//# sourceMappingURL=index.js.map